import { Button, Stack } from '@mui/material'
import { SKILL_TIERS } from '@/types/constants'
import type { SkillTierIndex } from '@/types'

interface Props {
  selectedTier: SkillTierIndex | null
  onSelect: (tier: SkillTierIndex | null) => void
}

export function TierList({ selectedTier, onSelect }: Props) {
  return (
    <Stack direction="column" spacing={0.5}>
      {SKILL_TIERS.map(({ index, label, range }) => {
        const isSelected = selectedTier === index
        return (
          <Button
            key={index}
            size="small"
            variant={isSelected ? 'contained' : 'text'}
            color={isSelected ? 'warning' : 'inherit'}
            onClick={() => onSelect(isSelected ? null : index)}
            sx={{
              justifyContent: 'flex-start',
              textAlign: 'left',
              fontWeight: isSelected ? 700 : 400,
              fontSize: '0.8rem',
              px: 1,
            }}
          >
            {label}
            <span style={{ marginLeft: 4, fontSize: '0.7rem', opacity: 0.7 }}>({range})</span>
          </Button>
        )
      })}
    </Stack>
  )
}
